import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const Header = ({ activeSection, onResumeClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "skills", label: "Skills" },
    { id: "projects", label: "Projects" },
    { id: "experience", label: "Experience" },
    { id: "awards", label: "Achievements" },
    { id: "certifications", label: "Certifications" },
    { id: "contact", label: "Contact" },
  ];

  // ✅ FIXED SCROLL FUNCTION (with navbar offset)
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);

    if (element) {
      const headerOffset = 100; // adjust if your header height is different
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "glass-nav glass-nav--scrolled"
          : "glass-nav"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <button
            onClick={() => scrollToSection("home")}
            className="flex items-center gap-3"
          >
            <img
              src="/logo.png"
              alt="Harish Kumar Logo"
              className="h-9 w-auto object-contain"
            />

            <span className="text-xl font-bold text-white">
              Harish <span className="text-emerald-400">Kumar</span>
            </span>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`text-sm font-medium transition-all duration-300 hover:text-emerald-400 ${
                  activeSection === item.id
                    ? "text-emerald-400"
                    : "text-gray-300"
                }`}
              >
                {item.label}
              </button>
            ))}

            <button
              onClick={onResumeClick}
              className="px-5 py-2 bg-emerald-500 text-white rounded-lg font-medium hover:bg-emerald-600 transition-all duration-300 hover:scale-105"
            >
              Resume
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white hover:text-emerald-400 transition-colors"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`block w-full text-left py-2 px-4 rounded-lg transition-all duration-300 ${
                  activeSection === item.id
                    ? "bg-emerald-500/20 text-emerald-400"
                    : "text-gray-300 hover:bg-slate-800"
                }`}
              >
                {item.label}
              </button>
            ))}

            <button
              onClick={() => {
                onResumeClick();
                setIsMobileMenuOpen(false);
              }}
              className="w-full py-2 px-4 bg-emerald-500 text-white rounded-lg font-medium hover:bg-emerald-600 transition-all duration-300"
            >
              Resume
            </button>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
